import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

import { AuthContext } from "../Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const STORAGE_KEY = "voicechat.layout";

// Fix 2026-10-29 (usuario reportou: "a pagina de senha tecnica nao esta
// funcionando" - tela em branco/crash). Causa: /senha-tecnica (e
// /painel-tv) sao rotas "standalone" DE PROPOSITO declaradas fora do
// <LayoutPreferenceProvider> em routes/index.js (nao devem ganhar o
// menu/cabecalho do app) - mas TechnicalPassword usa <MainContainer>,
// que desde o layout Novo (2026-10-22) le este contexto direto
// (`const { layout } = useContext(...)`) sem nenhuma guarda. Sem um
// Provider por perto, useContext devolve undefined e o destructuring
// quebra a tela inteira. createContext() sem valor padrao e' o que
// permite isso - um valor padrao aqui faz qualquer consumidor fora do
// Provider cair de volta pro Classico (comportamento sempre existente,
// antes do layout Novo) em vez de estourar. Zero mudanca pra quem esta
// dentro do Provider (o valor real do state sempre sobrescreve este
// default).
const LayoutPreferenceContext = createContext({ layout: "classic", setLayout: () => {} });

// Projeto "layout novo" (2026-10-21, ver PROMPT.md em D:\voicechat\novo
// layout). Guarda a preferencia "classic"/"new" em localStorage (efeito
// imediato, sem esperar rede) e replica pro backend via PUT /users/:id
// (mesmo endpoint que defaultMenu/defaultTheme ja usam) pra valer em
// outro computador tambem.
const LayoutPreferenceProvider = ({ children }) => {
	const { user } = useContext(AuthContext);
	const [layout, setLayoutState] = useState(() => {
		try {
			return localStorage.getItem(STORAGE_KEY) || "classic";
		} catch (e) {
			return "classic";
		}
	});

	// So' aplica o valor vindo do servidor uma vez, na primeira vez que o
	// usuario autenticado chega - depois disso o localStorage deste
	// navegador manda, pra nao sobrescrever uma troca feita nesta mesma
	// sessao caso o objeto "user" seja atualizado por outro motivo.
	const [syncedFromServer, setSyncedFromServer] = useState(false);
	useEffect(() => {
		if (!syncedFromServer && user?.layoutPreference) {
			setLayoutState(user.layoutPreference);
			try {
				localStorage.setItem(STORAGE_KEY, user.layoutPreference);
			} catch (e) {
				// localStorage indisponivel - segue so' com o estado em memoria
			}
			setSyncedFromServer(true);
		}
	}, [user, syncedFromServer]);

	const setLayout = useCallback(
		async (value) => {
			setLayoutState(value);
			try {
				localStorage.setItem(STORAGE_KEY, value);
			} catch (e) {
				// localStorage indisponivel - a troca ainda funciona nesta sessao
			}
			if (user?.id) {
				try {
					await api.put(`/users/${user.id}`, { layoutPreference: value });
				} catch (err) {
					toastError(err);
				}
			}
		},
		[user]
	);

	return (
		<LayoutPreferenceContext.Provider value={{ layout, setLayout }}>
			{children}
		</LayoutPreferenceContext.Provider>
	);
};

export { LayoutPreferenceContext, LayoutPreferenceProvider };
